/* eslint-disable eqeqeq */
import { Line, Paragraph, Row } from "meitav-uikit";
import React, { useEffect, useState } from "react";
import utils from "../../../../../../utils";
import Chart from "./Chart";
const { rest } = utils;

const HorizonalChartsWrapper = ({
  riskLevelLow,
  riskLevelHigh,
  className = "",
}) => {
  const [mediniyutHashkaa, setMediniyutHashkaa] = useState();
  useEffect(() => {
    GetMediniyutHashkaa();
  }, []);

  const GetMediniyutHashkaa = async () => {
    const investPolicyGUID = localStorage.getItem("investPolicyGUID");
    const deepLink = localStorage.getItem("deepLink");

    if (investPolicyGUID === null && deepLink!="true") {
     window.location.href = "/CustomerInvestPolicy";
    }
    const result = await rest.get(
      `/api/Manager/GetMediniyutHashkaa?investPolicyGUID=${investPolicyGUID}`
    );
    if (
      result == null ||
      result?.data == null ||
      result?.data?.MediniutLevel == 0
    ) {
    //  window.location.href = "/CustomerInvestPolicy";
    }
    setMediniyutHashkaa(result?.data);
  };

  if (mediniyutHashkaa)
    return (
      <Row className={`HorizonalChartsWrapper ${className}`}>
        <Row   >
            <Chart
              riskLevel={mediniyutHashkaa?.RiskLevel}
              riskLevelFirstName={riskLevelLow}
              riskLevelEndName={riskLevelHigh}
            />
        </Row>
        <Line>
            <Paragraph>{mediniyutHashkaa?.RiskLevelForShow}</Paragraph>
        </Line>
      </Row>
    );
  return "";
};
export default HorizonalChartsWrapper;
